/*
 * Dashboard
*/
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';
export const GET_DASHBOARD_DATA_ERROR = 'GET_DASHBOARD_DATA_ERROR';

export const LEADS_GET_DASHBOARD_DATA = 'LEADS_GET_DASHBOARD_DATA';
export const LEADS_GET_DASHBOARD_DATA_SUCCESS = 'LEADS_GET_DASHBOARD_DATA_SUCCESS';
export const LEADS_GET_DASHBOARD_DATA_ERROR = 'LEADS_GET_DASHBOARD_DATA_ERROR';

export const CALLS_GET_DASHBOARD_DATA = 'CALLS_GET_DASHBOARD_DATA';
export const CALLS_GET_DASHBOARD_DATA_SUCCESS = 'CALLS_GET_DASHBOARD_DATA_SUCCESS';
export const CALLS_GET_DASHBOARD_DATA_ERROR = 'CALLS_GET_DASHBOARD_DATA_ERROR';
export const RESET_DASHBOARD_ERROR = 'RESET_DASHBOARD_ERROR';


export const CLICK_INSURANCE_TYPE_METRICS = 'CLICK_INSURANCE_TYPE_METRICS';
export const CLICK_INSURANCE_TYPE_METRICS_SUCCESS = 'CLICK_INSURANCE_TYPE_METRICS_SUCCESS';
export const CLICK_INSURANCE_TYPE_METRICS_ERROR = 'CLICK_INSURANCE_TYPE_METRICS_ERROR';

export const LEAD_INSURANCE_TYPE_METRICS = 'LEAD_INSURANCE_TYPE_METRICS';
export const LEAD_INSURANCE_TYPE_METRICS_SUCCESS = 'LEAD_INSURANCE_TYPE_METRICS_SUCCESS';
export const LEAD_INSURANCE_TYPE_METRICS_ERROR = 'LEAD_INSURANCE_TYPE_METRICS_ERROR';

export const CALL_INSURANCE_TYPE_METRICS = 'CALL_INSURANCE_TYPE_METRICS';
export const CALL_INSURANCE_TYPE_METRICS_SUCCESS = 'CALL_INSURANCE_TYPE_METRICS_SUCCESS';
export const CALL_INSURANCE_TYPE_METRICS_ERROR = 'CALL_INSURANCE_TYPE_METRICS_ERROR';